import { useMutation, useQuery } from '@tanstack/react-query';
import { apiGet, apiPost } from './client';

export interface TwoFAStatus {
  twoFactorEnabled: boolean;
  recoveryCodesRemaining: number;
}

export interface TwoFASetupData {
  qrCode: string;
  totpUri: string;
}

export interface TwoFARecoveryCodes {
  recoveryCodes: string[];
}

export function use2FAStatus() {
  return useQuery<TwoFAStatus>({
    queryKey: ['2fa-status'],
    queryFn: () => apiGet<TwoFAStatus>('/auth/2fa/status'),
  });
}

export function use2FASetup() {
  return useMutation<TwoFASetupData, Error, void>({
    mutationFn: () => apiPost<TwoFASetupData>('/auth/2fa/setup'),
  });
}

export function use2FAVerifySetup() {
  return useMutation<TwoFARecoveryCodes, Error, string>({
    mutationFn: (code: string) => apiPost<TwoFARecoveryCodes>('/auth/2fa/verify-setup', { code }),
  });
}

export function use2FAVerify() {
  return useMutation<{ accessToken: string; user: unknown }, Error, { code: string; isRecovery: boolean }>({
    mutationFn: ({ code, isRecovery }) =>
      apiPost('/auth/2fa/verify', { code, isRecovery }),
  });
}

export function use2FADisable() {
  return useMutation<void, Error, { password: string; totpCode: string }>({
    mutationFn: ({ password, totpCode }) =>
      apiPost('/auth/2fa/disable', { password, totpCode }),
  });
}

export function use2FARegenerateRecoveryCodes() {
  return useMutation<TwoFARecoveryCodes, Error, string>({
    mutationFn: (totpCode: string) =>
      apiPost<TwoFARecoveryCodes>('/auth/2fa/recovery-codes/regenerate', { totpCode }),
  });
}
